import Navigator from 'app';
import LoadingView from './views/loading_view';
export default {
  createSpinner: function () {
    Navigator.loadingView = new LoadingView();
    Navigator.loadingRegion.show(Navigator.loadingView);
  },
  showSpinner: function () {
    // if(Navigator.loadingView.$el){
    try {
      Navigator.loadingView.$el.show();
    } catch (e) {
      console.log("EMD loading view does not exist");
    }
    //  }
  },

  hideSpinner: function () {
    Navigator.loadingView.$el.hide();
  }
};